import { render, staticRenderFns } from "./UserSettingsTopBar.vue?vue&type=template&id=537ccc84&scoped=true"
import script from "./UserSettingsTopBar.vue?vue&type=script&lang=ts"
export * from "./UserSettingsTopBar.vue?vue&type=script&lang=ts"
import style0 from "./UserSettingsTopBar.vue?vue&type=style&index=0&id=537ccc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ccc84",
  null
  
)

export default component.exports